'use strict';
import PropTypes from 'prop-types';
import React from 'react';

class UserMenuComponentTemplate extends React.Component {
    isMerchant() {
        if (
            this.props.user &&
            typeof this.props.user.Roles !== 'undefined' &&
            this.props.user.Roles != null &&
            (this.props.user.Roles.includes('Merchant') || this.props.user.Roles.includes('Submerchant'))
        ) {
            return true;
        }
        return false;
    }

    renderName() {
        const firstname = this.props.user.FirstName;
        const lastname = this.props.user.LastName;
        let displayName;
        if (firstname === null && lastname === null) {
            displayName = this.props.user.UserName;
        } else {
            displayName = this.props.user.FirstName + ' ' + this.props.user.LastName;
        }
        return <p>{this.props.user.DisplayName}</p>;
    }

    renderSettings() {
        if (
            typeof this.props.user.Roles !== 'undefined' &&
            this.props.user.Roles != null &&
            (this.props.user.Roles.includes('Merchant') || this.props.user.Roles.includes('Submerchant'))
        ) {
            return (
                <li>
                    <a href='/merchants/settings'>Settings</a>
                </li>
            );
        }

        return (
            <li>
                <a href='/users/settings'>Settings</a>
            </li>
        );
    }

    renderSellerSettings() {
        if (this.isMerchant()) {
            return (
                <>
                    <li>
                        <a href='/merchants/items'>Your Listings</a>
                    </li>
                    <li>
                        <a href='/merchants/upload'>Create New Listing</a>
                    </li>
                </>
            );
        }
    }

    renderFavorites() {
        return (
            <li className='h-wishlist-li'>
                <a href='/wishlist'>Favorites</a>
            </li>
        );
        // }
    }

    showUserMenu(event) {
        event.stopPropagation();
        $('.h-username')
            .find('.h-dd-menu')
            .slideToggle();
        $('.h-st-menus').hide();
        $('.h-cart .h-cart-menu').hide();
        $('.h-more .h-dd-menu').hide();
        $('.h-user .h-dd-menu').hide();
    }

    renderChangePasswordMenu() {
        let showChangepassword = false;
        if (this.props.user) {
            if (
                this.props.user.UserName &&
                !(this.props.user.UserName.startsWith('Facebook') || this.props.user.UserName.startsWith('Google'))
            ) {
                showChangepassword = true;
            } else if (this.props.user.UserLogins && this.props.user.UserLogins.length > 0) {
                const loginProviders = this.props.user.UserLogins.map(l => l.LoginProvider);
                showChangepassword = !loginProviders.includes('Facebook') && !loginProviders.includes('Google');
            }
        }

        if (showChangepassword) {
            return (
                <li>
                    <a href='/accounts/change-password'>Change Password</a>
                </li>
            );
        }
        return;
    }

    getRedirectLink() {
        //  if (typeof this.props.user.Roles !== 'undefined' && this.props.user.Roles != null && (this.props.user.Roles.includes('Merchant') || this.props.user.Roles.includes('Submerchant'))) {
        //      if (process.env.CHECKOUT_FLOW_TYPE == 'b2c') return "/merchants/order/history";
        //     return "/quotation/list";
        // }
        //if (process.env.CHECKOUT_FLOW_TYPE == 'b2c') return "/purchase/history";
        //return "/quotation/list?buyer=true";
        return '/purchase/history';
    }

    render() {
        if (typeof this.props.user !== 'undefined' && this.props.user != null && this.props.user.Guest === false) {
            return (
                <li
                    className={this.props.user.Guest ? 'h-username' : 'h-username hide-border'}
                    onClick={e => this.showUserMenu(e)}
                >
                    <span className='tw-flex tw-items-center'>
                        {this.renderName()}
                        <img className='icon-arrow-down' src='/assets/images/icon-arrow-down.svg' alt='' />
                    </span>
                    <ul className='h-dd-menu hide-me'>
                        {this.renderFavorites()}
                        {this.renderSellerSettings()}
                        <li>
                            <a href={this.getRedirectLink()}>Buyer Docs</a>
                        </li>
                        {this.renderSettings()}
                        {/* {this.renderChangePasswordMenu()} */}
                        <form action='/accounts/sign-out' method='post' style={{ cursor: 'pointer' }}>
                            <li>
                                <a id='signout-form' onClick={e => this.props.signOut(e)}>
                                    Logout
                                </a>
                            </li>
                        </form>
                    </ul>
                </li>
            );
        } else {
            function getLoginUrl() {
                let search = location.search;
                if (search) {
                    search = search.replace('?error=invalid-token', '');
                }

                let loc = (location.pathname + search).substr(1);
                return `/accounts/non-private/sign-in?returnUrl=${loc}`;
            }

            return (
                <li className='h-username'>
                    <a className='reg-btn' href={getLoginUrl()}>
                        Register/Sign In
                    </a>
                </li>
            );
        }
    }
}

UserMenuComponentTemplate.propTypes = {
    user: PropTypes.shape({
        Guest: PropTypes.bool,
        UserName: PropTypes.string,
        FirstName: PropTypes.string,
        LastName: PropTypes.string,
        DisplayName: PropTypes.string,
        Roles: PropTypes.arrayOf(PropTypes.string),
        UserLogins: PropTypes.arrayOf(
            PropTypes.shape({
                LoginProvider: PropTypes.string
            })
        )
    }),
    ControlFlags: PropTypes.shape({
        FavoriteWishlistSettings: PropTypes.shape({
            Name: PropTypes.string
        })
    }),
    signOut: PropTypes.func.isRequired
};

export default UserMenuComponentTemplate;
